"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/defineProperty"));

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.function.name");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _AffiliationGroup = _interopRequireDefault(require("./components/AffiliationGroup"));

var _auth = require("@/utils/auth");

var _button_pagination = _interopRequireDefault(require("@/views/widgets/button_pagination.vue"));

var _computed$components$;

var _default = (_computed$components$ = {
  computed: {},
  components: {
    AffiliationGroup: _AffiliationGroup.default,
    ButtonPagination: _button_pagination.default
  },
  data: function data() {
    return {
      device: {
        mobile: false
      },
      role: {},
      group_id: "",
      company: [],
      fileList: [],
      form: {
        companyName: "",
        representative: "",
        industry: "",
        roleSearch: null,
        tel: "",
        is_active: null
      },
      companies: [],
      drawer: false,
      titleSize: 3,
      title: "組織で検索",
      loading: false
    };
  }
}, (0, _defineProperty2.default)(_computed$components$, "computed", {
  coms: function coms() {
    return this.$store.getters.members;
  },
  currentPage: function currentPage() {
    return this.$store.getters.page_top;
  },
  maxPage: function maxPage() {
    return this.$store.getters.page_last;
  },
  userRoles: function userRoles() {
    return this.$store.getters.userRoles;
  },
  logins: function logins() {
    return this.$store.getters.loginOptions;
  },
  searchUserCount: function searchUserCount() {
    return this.$store.getters.searchUserCount;
  },
  searching: {
    get: function get() {
      return this.$store.getters.companieSearching;
    },
    set: function set(val) {
      this.$store.dispatch("company/setSearching", val);
    }
  },
  industry_major: function industry_major() {
    return this.$store.getters.industryMajorOptions;
  },
  industry_middle: function industry_middle() {
    return this.$store.getters.industryMiddleOptions;
  }
}), (0, _defineProperty2.default)(_computed$components$, "beforeMount", function () {
  var _beforeMount = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    var roleType;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            this.loading = true;
            this.searching = "";
            this.$store.commit("company/setRoleSearch", null);
            this.$store.commit("company/setIsActive", null);
            this.$store.commit("company/pathToListItem", []);
            this.$store.commit("company/getDataSearchAffiliation", []);
            this.$store.commit("company/setEnableTextAllSelect", true);
            _context.next = 9;
            return this.$store.dispatch("company/clear");

          case 9:
            _context.next = 11;
            return this.$store.dispatch("company/setSearching", "");

          case 11:
            _context.next = 13;
            return this.$store.dispatch("company/getSearchIndustryMajorList");

          case 13:
            _context.next = 15;
            return this.$store.dispatch("company/setPageTop", 0);

          case 15:
            this.$store.commit("company/setOptionValue", 1);
            _context.next = 18;
            return this.$store.dispatch("company/getLoginList");

          case 18:
            _context.next = 20;
            return this.$store.dispatch("company/getRoles");

          case 20:
            _context.next = 22;
            return this.$store.dispatch("company/fetchMembers");

          case 22:
            _context.next = 24;
            return (0, _auth.getUserPermission)();

          case 24:
            roleType = _context.sent;

            if (roleType) {
              this.role = JSON.parse(roleType);
            }

            this.device.mobile = this.$device.mobile;
            this.loading = false;

          case 28:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  function beforeMount() {
    return _beforeMount.apply(this, arguments);
  }

  return beforeMount;
}()), (0, _defineProperty2.default)(_computed$components$, "methods", {
  swapComponent: function swapComponent(data) {
    this.drawer = !this.drawer;
    var titleString = [];
    var item = this.$store.getters.pathToListItem;

    if (item && item.length) {
      this.$store.getters.pathToListItem.map(function (item) {
        return titleString.push(item.name);
      });

      if (item.length === 1) {
        this.titleSize = 3;
      } else {
        this.titleSize = 4 + item.length;
      }

      this.title = titleString.join(" / ");
    }
  },
  search: function () {
    var _search = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.$store.commit("company/setRoleSearch", this.form.roleSearch);

            case 2:
              _context2.next = 4;
              return this.$store.commit("company/setIsActive", this.form.is_active);

            case 4:
              _context2.next = 6;
              return this.$store.dispatch("company/setPageTop", 0);

            case 6:
              _context2.next = 8;
              return this.$store.dispatch("company/fetchMembers");

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function search() {
      return _search.apply(this, arguments);
    }

    return search;
  }(),
  changeIndustryMajor: function () {
    var _changeIndustryMajor = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.$store.dispatch("company/getSearchIndustryMiddleList", {
                group_id: this.$data.group_id
              });

            case 2:
              if (!(this.$data.group_id === 0)) {
                _context3.next = 8;
                break;
              }

              this.$data.form.industry = "00";
              _context3.next = 6;
              return this.$store.dispatch("company/setMiddleCode", null);

            case 6:
              _context3.next = 11;
              break;

            case 8:
              this.$data.form.industry = "00";
              _context3.next = 11;
              return this.$store.dispatch("company/setMiddleCode", null);

            case 11:
              if (!(this.$data.group_id === 0)) {
                _context3.next = 16;
                break;
              }

              _context3.next = 14;
              return this.$store.dispatch("company/setMajorCode", null);

            case 14:
              _context3.next = 18;
              break;

            case 16:
              _context3.next = 18;
              return this.$store.dispatch("company/setMajorCode", this.$data.group_id);

            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function changeIndustryMajor() {
      return _changeIndustryMajor.apply(this, arguments);
    }

    return changeIndustryMajor;
  }(),
  changeIndustryMiddle: function () {
    var _changeIndustryMiddle = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(this.$data.form.industry == "00")) {
                _context4.next = 5;
                break;
              }

              _context4.next = 3;
              return this.$store.dispatch("company/setMiddleCode", null);

            case 3:
              _context4.next = 7;
              break;

            case 5:
              _context4.next = 7;
              return this.$store.dispatch("company/setMiddleCode", this.$data.form.industry);

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function changeIndustryMiddle() {
      return _changeIndustryMiddle.apply(this, arguments);
    }

    return changeIndustryMiddle;
  }(),
  addCompany: function addCompany() {
    this.$router.push({
      name: "CompanyCreate"
    });
  },
  importCsv: function importCsv() {
    this.$router.push({
      name: "CompanyCsvImport"
    });
  },
  goToDetail: function goToDetail(data) {
    (0, _auth.setGoFromPage)("Company");
    this.$store.commit("company/setEnableTextAllSelect", false);
    this.$router.replace({
      name: "CompanyAdminEdit",
      params: {
        uid: data.uid
      }
    });
  },
  goToEventPerCo: function goToEventPerCo(data) {
    this.$router.replace({
      name: "PerCompany",
      params: {
        data: data
      }
    });
  },
  handleSelect: function handleSelect() {},
  goTopPage: function () {
    var _goTopPage = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.$store.dispatch("company/setPageTop", 0);

            case 2:
              _context5.next = 4;
              return this.$store.dispatch("company/fetchMembers");

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function goTopPage() {
      return _goTopPage.apply(this, arguments);
    }

    return goTopPage;
  }(),
  goPrePage: function () {
    var _goPrePage = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee6() {
      var pre;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.$store.dispatch("company/getPageTop");

            case 2:
              pre = _context6.sent;

              if (!(pre > 0)) {
                _context6.next = 8;
                break;
              }

              _context6.next = 6;
              return this.$store.dispatch("company/setPageTop", pre - 1);

            case 6:
              _context6.next = 8;
              return this.$store.dispatch("company/fetchMembers");

            case 8:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function goPrePage() {
      return _goPrePage.apply(this, arguments);
    }

    return goPrePage;
  }(),
  goNextPage: function () {
    var _goNextPage = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee7() {
      var next, last;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.$store.dispatch("company/getPageTop");

            case 2:
              next = _context7.sent;
              _context7.t0 = Math;
              _context7.next = 6;
              return this.$store.dispatch("company/getPageLast");

            case 6:
              _context7.t1 = _context7.sent;
              last = _context7.t0.floor.call(_context7.t0, _context7.t1);

              if (!(last > next)) {
                _context7.next = 13;
                break;
              }

              _context7.next = 11;
              return this.$store.dispatch("company/setPageTop", next + 1);

            case 11:
              _context7.next = 13;
              return this.$store.dispatch("company/fetchMembers");

            case 13:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function goNextPage() {
      return _goNextPage.apply(this, arguments);
    }

    return goNextPage;
  }(),
  goLastPage: function () {
    var _goLastPage = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee8() {
      var last;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.t0 = Math;
              _context8.next = 3;
              return this.$store.dispatch("company/getPageLast");

            case 3:
              _context8.t1 = _context8.sent;
              last = _context8.t0.floor.call(_context8.t0, _context8.t1);
              _context8.next = 7;
              return this.$store.dispatch("company/setPageTop", last);

            case 7:
              _context8.next = 9;
              return this.$store.dispatch("company/fetchMembers");

            case 9:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    function goLastPage() {
      return _goLastPage.apply(this, arguments);
    }

    return goLastPage;
  }(),
  handleOpen: function handleOpen(key, keyPath) {},
  handleClose: function handleClose(key, keyPath) {},
  onSubmit: function onSubmit() {},
  toggleDrawer: function toggleDrawer() {
    this.drawer = !this.drawer;
  },
  querySearch: function () {
    var _querySearch = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee9(query) {
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.$store.dispatch("company/setPageTop", 0);

            case 2:
              _context9.next = 4;
              return this.$store.dispatch("company/fetchMembers");

            case 4:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    function querySearch(_x) {
      return _querySearch.apply(this, arguments);
    }

    return querySearch;
  }()
}), _computed$components$);

exports.default = _default;